// extracted by mini-css-extract-plugin
module.exports = {"counterContainer":"ReportCounter_counterContainer__1jQM-","reportCount":"ReportCounter_reportCount__1EUA0","description":"ReportCounter_description__2sHAd"};